export function Mission() {
  return (
    <div className='card' id='mission'>
      <h2>Missão</h2>
      <section className="mission">  
        <p>
          A República do Boxe é uma academia de boxe em Santos que tem como missão
          compartilhar nossa paixão pela nobre arte e promovê-la como um esporte acessível a todos.
          Nosso objetivo é te dar um novo hobby, uma nova forma de passar seu tempo livre e descobrir 
          habilidades que você nem sabia que tinha. Queremos que você se divirta e nem lembre que está
          se exercitando.
          Venha nos visitar e descubra como o boxe pode transformar sua vida!
        </p>
      </section>
    </div>
  );
}